import React, { FC, useContext } from 'react'
import {
    StyledBackNav,
    StyledMainScreen,
    StyledIconChevron,
} from './MainScreen.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { TNToastComponent } from '../../content/TNToastNotification/TNToastNotification'
import { UserSettingProps } from '../UserSetting'
import { ScreenType, getScreens } from '../hooks/useScreen'
import { useProduct } from '../../__product'
import { Product } from '@news-mono/web-common'
import { EmailBanner } from '../components/EmailBanner'
import { tokens } from '@news-mono/design-tokens'
import { PNToastComponent } from '../../content'
import { calcRem } from '../../__styling'

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette

interface MainScreenProps extends UserSettingProps {
    screen: ScreenType
    /* `show` is only evaluated on sm screen */
    show?: boolean
}
export const MainScreen: FC<MainScreenProps> = ({
    screen,
    show = false,
    onEvent,
    log,
    config,
}) => {
    const product = useProduct()
    const { messageBanner, goBackToParent } = useContext(MyAccountContext)
    const showOnLargeScreen = screen !== 'manage-account'
    const screens = getScreens(product)
    const isPn = product === Product.PerthNow

    const {
        body: Screen,
        headingText,
        subHeadingText,
        parent,
        navText,
    } = screens[screen]

    return (
        <StyledMainScreen show={show}>
            {!isPn && messageBanner && (
                <TNToastComponent
                    text={messageBanner.text}
                    type={messageBanner.type}
                    useMaxWidth={true}
                    forceMaxWidth={true}
                />
            )}
            {(parent || navText) && (
                <StyledBackNav
                    onClick={() => goBackToParent(true)}
                    showOnLargeScreen={showOnLargeScreen}
                    tabIndex={0}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            goBackToParent(true)
                        }
                    }}
                >
                    <StyledIconChevron
                        direction="left"
                        color={isPn ? pnPalette.greyWeak : undefined}
                    />
                    <span>
                        {navText
                            ? navText
                            : parent
                            ? screens[parent].headingText
                            : 'Unknown Parent'}
                    </span>
                </StyledBackNav>
            )}
            <h2 className={subHeadingText ? '' : 'bottom-header'}>
                {headingText}
            </h2>
            {subHeadingText && (
                <h4 className="bottom-header">{subHeadingText}</h4>
            )}
            {isPn && screen === 'manage-account' && <EmailBanner />}
            {isPn && messageBanner && (
                <PNToastComponent
                    text={messageBanner.text}
                    type={messageBanner.type}
                    useMaxWidth={false}
                    forceMaxWidth={true}
                    marginTop={calcRem(32)}
                />
            )}
            <Screen onEvent={onEvent} log={log} config={config} />
        </StyledMainScreen>
    )
}
